import { Card } from '../../components/Card/Card';
import { Divider } from '../../../components/Divider';
import { DividedPage } from '../../../components/DividedPage';
import { Error } from '../../../components/Error';
import { Loading } from '../../../components/Loading';
import { useOrderHistoryQuery } from '../../graphql';

export const Root: React.FC = () => {
	const { data, error } = useOrderHistoryQuery({
		fetchPolicy: 'network-only'
	});

	if (error) {
		return <Error error={error.message} />;
	}

	if (!data) {
		return <Loading />;
	}

	const noOrders =
		!data.session.profile || data.session.profile.orderHistory.length === 0;

	return (
		<div className="mb-3 order-root">
			<h1 className="mb-0">Past Orders</h1>

			<Divider mt={0} />

			{noOrders ? (
				<div className="alert alert-info">No orders to show yet.</div>
			) : (
				<DividedPage
					dividerProps={{ spacingOnly: true }}
					children={data.session.profile?.orderHistory
						.slice()
						.sort((a, b) => {
							const aDate = new Date(a.timePlaced).getTime();
							const bDate = new Date(b.timePlaced).getTime();

							return bDate - aDate;
						})
						.map((order, key) => (
							<Card order={order} key={key} />
						))}
				/>
			)}
		</div>
	);
};
